module.exports = __webpack_public_path__ + "fbe667cca7bbd662d587654ac2702d81.png";